var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle, _polygon, _circle2, _path21, _path22, _path23, _path24, _path25, _polygon2, _rect6, _rect7, _path26, _path27, _polygon3, _path28, _path29, _circle3, _polygon4, _path30, _path31, _path32, _path33;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a3264d4e-838f-4e8b-aa0e-ebd578e83807",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 917.43975,
    height: 680.09887,
    viewBox: "0 0 917.43975 680.09887",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285.71987,345.03692a69,69,0,0,1,0-138h628a69,69,0,0,1,0,138Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M285.71987,216.03692a60,60,0,0,0,0,120h628a60,60,0,0,0,0-120Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 208.10659,
    y: 106.08655,
    width: 2,
    height: 120,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 332.9396,
    y: 106.08655,
    width: 2,
    height: 120,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 457.9396,
    y: 106.08655,
    width: 2,
    height: 120,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 581.9396,
    y: 106.08655,
    width: 2,
    height: 120,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 706.9396,
    y: 106.08655,
    width: 2,
    height: 120,
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M383.89735,258.03692a2.89561,2.89561,0,0,0,0,5.79123H442.6369a2.89562,2.89562,0,1,0,0-5.79123Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M383.89735,273.03692a2.89561,2.89561,0,0,0,0,5.79123H442.6369a2.89562,2.89562,0,1,0,0-5.79123Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M383.89735,288.03692a2.89561,2.89561,0,0,0,0,5.79123H442.6369a2.89562,2.89562,0,1,0,0-5.79123Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M507.89735,258.03692a2.89561,2.89561,0,0,0,0,5.79123H566.6369a2.89561,2.89561,0,1,0,0-5.79123Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#7105ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M507.89735,273.03692a2.89561,2.89561,0,0,0,0,5.79123H566.6369a2.89561,2.89561,0,1,0,0-5.79123Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#7105ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M507.89735,288.03692a2.89561,2.89561,0,0,0,0,5.79123H566.6369a2.89561,2.89561,0,1,0,0-5.79123Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#7105ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M632.89735,258.03692a2.89562,2.89562,0,0,0,0,5.79123H691.6369a2.89561,2.89561,0,1,0,0-5.79123Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M632.89735,273.03692a2.89562,2.89562,0,0,0,0,5.79123H691.6369a2.89561,2.89561,0,1,0,0-5.79123Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M632.89735,288.03692a2.89562,2.89562,0,0,0,0,5.79123H691.6369a2.89561,2.89561,0,1,0,0-5.79123Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#e6e6e6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M757.39735,258.03692a2.89562,2.89562,0,0,0,0,5.79123H816.1369a2.89561,2.89561,0,1,0,0-5.79123Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M757.39735,273.03692a2.89562,2.89562,0,0,0,0,5.79123H816.1369a2.89561,2.89561,0,1,0,0-5.79123Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M757.39735,288.03692a2.89562,2.89562,0,0,0,0,5.79123H816.1369a2.89561,2.89561,0,1,0,0-5.79123Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M878.89735,258.03692a2.89562,2.89562,0,0,0,0,5.79123H937.6369a2.89561,2.89561,0,1,0,0-5.79123Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#e6e6e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M878.89735,273.03692a2.89562,2.89562,0,0,0,0,5.79123H937.6369a2.89561,2.89561,0,1,0,0-5.79123Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M878.89735,288.03692a2.89562,2.89562,0,0,0,0,5.79123H937.6369a2.89561,2.89561,0,1,0,0-5.79123Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M258.89735,258.03692a2.89562,2.89562,0,0,0,0,5.79123H317.6369a2.89562,2.89562,0,1,0,0-5.79123Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M258.89735,273.03692a2.89562,2.89562,0,0,0,0,5.79123H317.6369a2.89562,2.89562,0,1,0,0-5.79123Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#e6e6e6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M258.89735,288.03692a2.89562,2.89562,0,0,0,0,5.79123H317.6369a2.89562,2.89562,0,1,0,0-5.79123Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 396.05763,
    cy: 47.38212,
    r: 47.38212,
    fill: "#7105ff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "396.058 124.408 381.242 98.747 366.427 73.086 396.058 73.086 425.688 73.086 410.873 98.747 396.058 124.408",
    fill: "#7105ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.43975,
    cy: 47.08636,
    r: 17,
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1029.92355,247.13623a28.79631,28.79631,0,1,0,28.79632,28.79629A28.79629,28.79629,0,0,0,1029.92355,247.13623Zm0,53.33839a24.54209,24.54209,0,1,1,24.5421-24.5421A24.54208,24.54208,0,0,1,1029.92355,300.47462Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#e6e6e6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.33256,285.78061a1.51843,1.51843,0,0,1-1.07424-.44513l-8.20458-8.20457a1.5192,1.5192,0,0,1,2.14848-2.14848l6.95229,6.95229,12.32318-16.80443a1.51945,1.51945,0,0,1,2.45057,1.79713l-13.37042,18.23239a1.52072,1.52072,0,0,1-1.10955.61665C1028.40971,285.77942,1028.37084,285.78061,1028.33256,285.78061Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#7105ff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M170.07641,247.13623a28.79631,28.79631,0,1,0,28.79633,28.79629A28.79628,28.79628,0,0,0,170.07641,247.13623Zm0,53.33839a24.54209,24.54209,0,1,1,24.5421-24.5421A24.54208,24.54208,0,0,1,170.07641,300.47462Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#e6e6e6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M162.39134,285.54855a1.51937,1.51937,0,0,1-1.07424-2.5936l16.19371-16.19312a1.5192,1.5192,0,1,1,2.14848,2.14848l-16.19371,16.19311A1.51443,1.51443,0,0,1,162.39134,285.54855Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#7105ff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M177.76127,285.54855a1.5144,1.5144,0,0,1-1.07424-.44513l-16.19312-16.19311a1.5192,1.5192,0,1,1,2.14848-2.14848L178.8355,282.955a1.51937,1.51937,0,0,1-1.07423,2.5936Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#7105ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "840.792 666.843 573.391 666.843 573.391 664.658 841.188 664.658 840.792 666.843",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 639.8122,
    y: 637.19213,
    width: 18.60392,
    height: 25.30133,
    fill: "#ffb8b8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 734.3201,
    y: 637.19213,
    width: 18.60392,
    height: 25.30133,
    fill: "#ffb8b8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M907.1104,537.29049h0a11.03954,11.03954,0,0,1-10.90618-12.75032l3.047-19.42475.90618-5.77693h14.139l.74416,8.18573,2.94415,16.82373A11.03955,11.03955,0,0,1,907.1104,537.29049Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#ffb8b8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M768.69725,535.058h0A11.03954,11.03954,0,0,1,757.791,522.3077l3.047-19.42475.90619-5.77693h14.139l.74416,8.18573,2.94415,16.82373A11.03954,11.03954,0,0,1,768.69725,535.058Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#ffb8b8"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "755.156 642.401 732.832 641.657 696.368 421.387 659.904 642.401 638.324 641.657 632.371 387.155 757.389 387.155 755.156 642.401",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M799.23007,790.00988c-18.94115.54786-33.76818-4.57266-43.48954-16.72781a8.02988,8.02988,0,0,1-.60774-9.1433h0a8.02807,8.02807,0,0,1,7.816-3.84338l6.15512.71943,12.81675-6.40422c-2.62193,15.24694,4.50961,15.53388,21.56893,10.42332l3.07336,15.751A7.73486,7.73486,0,0,1,799.23007,790.00988Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#2f2e41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M893.738,790.00988c-18.94115.54786-33.76818-4.57266-43.48955-16.72781a8.02989,8.02989,0,0,1-.60773-9.1433h0a8.02807,8.02807,0,0,1,7.816-3.84338l6.15512.71943,12.72056-5.36672c-2.62193,15.24693,4.6058,14.49638,21.66512,9.38582l3.07336,15.751A7.73486,7.73486,0,0,1,893.738,790.00988Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 688.92654,
    cy: 124.46812,
    r: 29.76627,
    fill: "#ffb8b8"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "718.693 178.792 686.694 180.28 685.206 146.793 712.74 136.375 718.693 178.792",
    fill: "#ffb8b8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M906.11066,507.52422c-43.63619-8.25688-93.35044-11.21495-126.50665,0L790.0222,288.74213l34.97537-10.41819,2.60455-4.09287,29.39419-4.837,14.139,4.46494,8.92988,13.39482,38.69615,21.58054C899.71356,382.51754,894.07161,449.46362,906.11066,507.52422Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#3f3d56"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M926.94705,506.03591l-31.99874-3.72079c6.66972-32.49693,3.94209-74.76625,5.58117-117.20469,1.03955-26.91553,6.62166-51.41087,8.5578-81.48516h0c12.13561,3.16442,18.41861,14.43324,18.49092,27.71334C927.92112,394.32525,933.87066,453.34268,926.94705,506.03591Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#3f3d56"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M787.78973,503.05928l-31.25458-2.23247,18.60392-105.67026,6.29835-87.93423c-.98007-12.82368,5.87386-20.27505,16.02635-20.71265h0c22.177,26.2617,24.74848,62.45392,17.85976,103.43779Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#3f3d56"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M839.86081,256.30431l-3.83876-10.92767a35.84234,35.84234,0,0,0-28.39866-23.55117h0l-24.05749-.55155,6.67953-10.73421a32.6397,32.6397,0,0,1,30.94992-15.23426l24.04314,2.39663a21.77935,21.77935,0,0,1,19.525,23.69415l-2.205,23.64583A14.89339,14.89339,0,0,1,839.86081,256.30431Z",
    transform: "translate(-141.28013 -109.95056)",
    fill: "#2f2e41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.04abc131717ebe203bd1feef518e6aa2.svg";
export { ForwardRef as ReactComponent };